export { HOME_STARTER_QUESTIONS } from './composerStarterQuestions';

export const MAX_RECENTLY_VIEWED_VEHICLES = 25;
